
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34864',
  depVersions: {
  "documents-public-ui": "static-1.34864",
  "atom": "static-1.5215",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2638",
  "client-types": "static-1.487",
  "cssUtils": "static-1.835",
  "customer-data-filters-ui": "static-1.40295",
  "customer-data-objects": "static-1.7818",
  "customer-data-property-utils": "static-1.8234",
  "documents-lib": "static-1.34869",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.350",
  "FormsCommonComponents": "static-1.86193",
  "FormUrlGenerator": "static-2.4862",
  "foundations-theming-specialty": "static-1.2290",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.106",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5733",
  "hs-test-utils": "static-1.8161",
  "hub-http": "static-1.6361",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11918",
  "HubStyleTokens": "static-2.11611",
  "I18n": "static-7.1643",
  "icons": "static-2.658",
  "jasmine-immutable": "static-1.3161",
  "jasmine-runner": "static-1.6596",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7292",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5536",
  "quartz": "static-1.7216",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16828",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5447",
  "react-virtualized": "static-2.101",
  "reference-resolvers": "static-1.8315",
  "reference-resolvers-lite": "static-1.8236",
  "reporting-data": "static-1.68119",
  "reporting-reports": "static-1.67797",
  "reporting-snowflake": "static-1.56737",
  "reporting-testing-lib": "static-1.10052",
  "reporting-visualizations": "static-1.60195",
  "reselect": "static-3.7",
  "sales-content-partitioning": "static-1.9088",
  "sanitize": "static-1.4616",
  "sanitize-text": "static-1.8286",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1884",
  "signup-constants": "static-1.19213",
  "signup-ui-url-generator": "static-2.8199",
  "StyleGuideUI": "static-3.490",
  "superstore": "static-1.4899",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4900",
  "ui-addon-form-validation": "static-1.11131",
  "ui-asset-management-lib": "static-1.11219",
  "ui-images": "static-2.1193",
  "UIComponents": "static-3.8557",
  "usage-tracker": "static-1.7492",
  "usage-tracker-container": "static-1.7482",
  "usage-tracker-core": "static-1.7342",
  "viral-links-lib": "static-1.7211",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9799",
  "foundations-components": "static-1.8214",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.994",
  "quartz-core": "static-1.6435",
  "quick-fetch": "static-1.4024",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4796",
  "ui-addon-i18n": "static-1.11288",
  "ui-addon-upgrades": "static-9.18185",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3507",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3493",
  "quartz-webpack": "static-1.3440",
  "foundations-assets": "static-1.5013",
  "foundations-theming": "static-1.4574",
  "hub-http-shared-msw-handlers": "static-1.10310",
  "hubspotter-http": "static-1.4757",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7387",
  "crm-message-bus": "static-1.43358",
  "customer-data-filters-ui-msw-helpers": "static-1.22730",
  "customer-data-objects-ui-components": "static-1.13169",
  "customer-data-reference-ui-components": "static-1.13315",
  "customer-data-ui-utilities": "static-1.9964",
  "events-data-lib": "static-1.377",
  "framework-builder-read-service-client": "static-1.4112",
  "framework-data-schema-quick-fetch": "static-1.6938",
  "framework-data-schema-resolvers": "static-1.7033",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3694",
  "inbound-db-properties-service-client": "static-1.3953",
  "multi-account-reference-resolvers": "static-1.1121",
  "onboarding-tours": "static-1.16874",
  "reporting-datasets-permissions-lib": "static-1.14079",
  "stylex": "static-1.36",
  "trellis-assets": "static-1.2226",
  "trellis-components": "static-1.2245",
  "trellis-theming": "static-1.1083",
  "ui-addon-teams": "static-1.21733",
  "quartz-auth": "static-1.891",
  "ui-business-units-lib": "static-1.9210",
  "usage-tracker-session-replay": "static-1.5178",
  "ai-components-ui-library": "static-1.9299",
  "ContentUtils": "static-1.68772",
  "customer-data-properties": "static-1.52034",
  "forms-ai-lib": "static-1.4542",
  "forms-utils-lib": "static-1.12850",
  "foundations-components-test-utils": "static-1.5697",
  "react-dnd-compat": "static-1.4754",
  "react-tinymce": "static-1.55613",
  "tinymce-config": "static-2.54739",
  "ui-gdpr-components": "static-1.10492",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3559",
  "HeadJS": "static-2.775",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3272",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "hs-locale-management": "static-1.188",
  "ui-fonts": "static-1.873",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4464",
  "csstype": "static-1.50",
  "quartz-head": "static-1.881",
  "web-vitals": "static-1.8",
  "batch-promise": "static-1.1684",
  "external-options-client-types": "static-1.4233",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.891",
  "frontend-preferences-client": "static-1.8066",
  "graphql": "static-1.84",
  "persist-promise": "static-1.3841",
  "reporting-client-types": "static-1.2586",
  "apollo-stack-hubspot": "static-3.88",
  "growth-payments-core": "static-1.25786",
  "hubspot-apollo-client": "static-1.5017",
  "foundations-components-legacy": "static-1.1239",
  "quartz-routing": "static-1.646",
  "hs-story-utils": "static-1.9563",
  "react-flip-move": "static-1.73",
  "nested-table": "static-1.379",
  "timezone-utils": "static-2.5383",
  "seat-types-lib": "static-1.311",
  "react-create-root-preference": "static-1.41",
  "bend-plugin-foundations-components": "static-1.4483",
  "floating-ui": "static-1.59",
  "react-aria": "static-1.68",
  "tanstack-table": "static-1.57",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-test": "static-1.891",
  "quartz-tracking": "static-1.595",
  "bend-plugin-chirp-manifest": "static-1.206",
  "chirp-fetch": "static-1.2027",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6128",
  "salesImages": "static-1.528",
  "ts-schema": "static-1.4188",
  "bender-build-tools": "static-1.3301",
  "bend-plugin-foundations-theming": "static-1.3057",
  "restore-request-side-panel-lib": "static-1.1252",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.319",
  "pulse": "static-1.746",
  "conditional-properties-service-client": "static-1.3904",
  "crm-pipelines-api-client-types": "static-1.4244",
  "fdsr-migration-layer": "static-1.152",
  "multi-currency-client-types": "static-1.3798",
  "getting-started-shared-tasks": "static-1.18802",
  "growth-data-modal": "static-1.5663",
  "growth-onboarding-confetti": "static-1.3205",
  "growth-onboarding-next-action-utils": "static-1.2317",
  "navigation-components": "static-1.18350",
  "onboarding-tours-client": "static-1.5088",
  "onboarding-tours-utils": "static-1.940",
  "ui-shepherd-react": "static-3.10397",
  "ui-shepherd-tracker": "static-1.7778",
  "ui-universal-auth": "static-1.9146",
  "user-context": "static-1.5248",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "tanstack-virtual": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.10308",
  "magpie-lib": "static-1.5644",
  "navigation-messaging": "static-1.7677",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21985",
  "copilot-toolkit": "static-1.11494",
  "cms-field-types": "static-1.4954",
  "content-icons-ui": "static-1.2270",
  "integrations-lib": "static-1.16594",
  "calling-global-api": "static-1.64972",
  "calling-internal-common": "static-1.31452",
  "calling-lifecycle-internal": "static-1.66354",
  "calling-lifecycle-messages": "static-1.58648",
  "commerce-products-lib": "static-1.10081",
  "crm-links": "static-1.6448",
  "customer-data-properties-shared-msw-handlers": "static-1.9637",
  "file-manager-components": "static-1.24039",
  "formula-editor": "static-1.14514",
  "google-libphonenumber": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4324",
  "meetings-icalendar-utils-lib": "static-1.773",
  "object-builder-ui-client": "static-1.49230",
  "pipeline-validation-client-types": "static-1.4073",
  "property-value-citations": "static-1.2648",
  "smart-property-lib": "static-1.7989",
  "tiered-pricing": "static-1.1596",
  "topics-actions-lib": "static-1.237",
  "ui-addon-iframeable": "static-1.9209",
  "zustand": "static-1.74",
  "final-form": "static-1.72",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20077",
  "tinymce-themes": "static-1.56709",
  "data-token-picker": "static-1.16657",
  "hub-http-contrib": "static-1.3183",
  "interframe": "static-3.4898",
  "tinymce-data": "static-1.40824",
  "tinymce-plugins": "static-1.57853",
  "ui-addon-sales-email": "static-1.5350",
  "onboarding-scopes": "static-1.6600",
  "ui-addon-opt": "static-4.8501",
  "apollo-link-hub-http": "static-2.4791",
  "hubspot-apollo-cache": "static-1.476",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.313",
  "purchase-motions-api": "static-1.6131",
  "event-emitter": "static-1.1089",
  "bend-plugin-pulse": "static-1.249",
  "fast-json-patch": "static-1.65",
  "onboarding-data-sync-lib": "static-1.2212",
  "growth-onboarding-next-action-components": "static-1.2345",
  "user-context-client": "static-1.4718",
  "idb-keyval": "static-1.46",
  "magpie-types": "static-1.5104",
  "nest": "static-1.373",
  "reactive-lib": "static-1.865",
  "simple-logging-lib": "static-1.3188",
  "unified-auth-core-lib": "static-1.942",
  "getting-started-shared-tasks-store": "static-1.17920",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1199",
  "integrations-error-boundary-lib": "static-1.14009",
  "integrations-tracking-lib": "static-1.5747",
  "native-integrations-shared-strings": "static-1.7920",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10502",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.660",
  "calling-error-reporting": "static-1.31459",
  "shared-worker-versioning": "static-1.11175",
  "calling-usage-tracker": "static-1.6682",
  "voice-sms-access-library": "static-1.1508",
  "customer-data-tracking": "static-1.7026",
  "commerce-permissions": "static-1.914",
  "products-iframe-lib": "static-1.8315",
  "products-ui-components-shared-msw-handlers": "static-1.10692",
  "location-customization-utils-lib": "static-1.9656",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4290",
  "video-components-external": "static-1.11747",
  "video-data-lib": "static-1.35405",
  "bark-lib": "static-1.16605",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.97",
  "crm-properties-common-lib": "static-1.6030",
  "react-codemirror": "static-1.10767",
  "data-agent-kit": "static-1.430",
  "feedback-loader": "static-1.29560",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10393",
  "fsm": "static-1.3870",
  "policy-lib": "static-1.6925",
  "react-colorpicker": "static-2.10347",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10456",
  "FileManagerLib": "static-1.39679",
  "NamespacedHubStyle": "static-2.9160",
  "FileManagerCore": "static-1.39538",
  "content-assistance-lib": "static-1.7979",
  "layout-dnd-components": "static-1.12722",
  "layout-dnd-utils": "static-1.11697",
  "ui-addon-emoji-picker": "static-1.10024",
  "ui-brand-identity-lib": "static-1.15797",
  "InboxConnectUtils": "static-4.15191",
  "meetings-connect-utils-lib": "static-1.7745",
  "breeze-engine-core": "static-1.477",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "universal-page-editor-lib": "static-1.3151",
  "adobe-sign-auth-lib": "static-1.83",
  "ads-unified-auth-lib": "static-1.543",
  "google-sheets-integration-lib": "static-1.645",
  "microsoft-drive-integration-lib": "static-1.808",
  "surveymonkey-integration-lib": "static-1.102",
  "slack-ui-library": "static-1.10538",
  "calling-orchestration-schema": "static-1.36285",
  "sales-views-client-types": "static-1.4397",
  "crm-record-cards-service-types": "static-1.3692",
  "content-media-composition-data-lib": "static-1.12752",
  "content-media-compositions": "static-2.16759",
  "media-bridge-lib": "static-1.19174",
  "react-reducer-toolkit": "static-1.15978",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4649",
  "storybook-react": "static-1.35",
  "audio-components": "static-1.6135",
  "FileManagerImages": "static-1.37190",
  "video-components": "static-1.13749",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4674",
  "video-embed": "static-1.36239",
  "ui-addon-video-player": "static-1.8845",
  "ui-coaching-tips": "static-1.28947",
  "ContentData": "static-1.68847",
  "layout-data-lib": "static-1.10022",
  "social-insights-client-types": "static-1.22418",
  "outpost": "static-1.4309",
  "growth-onboarding-feedback-components": "static-1.6718",
  "advanced-menus-core": "static-1.15367",
  "advanced-menus-lib": "static-1.12272",
  "ExportDialog": "static-6.10519",
  "ui-memberships-settings-lib": "static-1.34422",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15366",
  "simple-menus-lib": "static-1.16883"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34864",
  "atom": "/atom/static-1.5215",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2638",
  "client-types": "/client-types/static-1.487",
  "cssUtils": "/cssUtils/static-1.835",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40295",
  "customer-data-objects": "/customer-data-objects/static-1.7818",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8234",
  "documents-lib": "/documents-lib/static-1.34869",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.350",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86193",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4862",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2290",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.106",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5733",
  "hs-test-utils": "/hs-test-utils/static-1.8161",
  "hub-http": "/hub-http/static-1.6361",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11918",
  "HubStyleTokens": "/HubStyleTokens/static-2.11611",
  "I18n": "/I18n/static-7.1643",
  "icons": "/icons/static-2.658",
  "jasmine-immutable": "/jasmine-immutable/static-1.3161",
  "jasmine-runner": "/jasmine-runner/static-1.6596",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7292",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5536",
  "quartz": "/quartz/static-1.7216",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16828",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5447",
  "react-virtualized": "/react-virtualized/static-2.101",
  "reference-resolvers": "/reference-resolvers/static-1.8315",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8236",
  "reporting-data": "/reporting-data/static-1.68119",
  "reporting-reports": "/reporting-reports/static-1.67797",
  "reporting-snowflake": "/reporting-snowflake/static-1.56737",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10052",
  "reporting-visualizations": "/reporting-visualizations/static-1.60195",
  "reselect": "/reselect/static-3.7",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9088",
  "sanitize": "/sanitize/static-1.4616",
  "sanitize-text": "/sanitize-text/static-1.8286",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1884",
  "signup-constants": "/signup-constants/static-1.19213",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8199",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "superstore": "/superstore/static-1.4899",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4900",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11131",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11219",
  "ui-images": "/ui-images/static-2.1193",
  "UIComponents": "/UIComponents/static-3.8557",
  "usage-tracker": "/usage-tracker/static-1.7492",
  "usage-tracker-container": "/usage-tracker-container/static-1.7482",
  "usage-tracker-core": "/usage-tracker-core/static-1.7342",
  "viral-links-lib": "/viral-links-lib/static-1.7211",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9799",
  "foundations-components": "/foundations-components/static-1.8214",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.994",
  "quartz-core": "/quartz-core/static-1.6435",
  "quick-fetch": "/quick-fetch/static-1.4024",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4796",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11288",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18185",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3507",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3493",
  "quartz-webpack": "/quartz-webpack/static-1.3440",
  "foundations-assets": "/foundations-assets/static-1.5013",
  "foundations-theming": "/foundations-theming/static-1.4574",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10310",
  "hubspotter-http": "/hubspotter-http/static-1.4757",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7387",
  "crm-message-bus": "/crm-message-bus/static-1.43358",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22730",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13169",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13315",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9964",
  "events-data-lib": "/events-data-lib/static-1.377",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4112",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6938",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7033",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3694",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3953",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1121",
  "onboarding-tours": "/onboarding-tours/static-1.16874",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14079",
  "stylex": "/stylex/static-1.36",
  "trellis-assets": "/trellis-assets/static-1.2226",
  "trellis-components": "/trellis-components/static-1.2245",
  "trellis-theming": "/trellis-theming/static-1.1083",
  "ui-addon-teams": "/ui-addon-teams/static-1.21733",
  "quartz-auth": "/quartz-auth/static-1.891",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9210",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5178",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9299",
  "ContentUtils": "/ContentUtils/static-1.68772",
  "customer-data-properties": "/customer-data-properties/static-1.52034",
  "forms-ai-lib": "/forms-ai-lib/static-1.4542",
  "forms-utils-lib": "/forms-utils-lib/static-1.12850",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5697",
  "react-dnd-compat": "/react-dnd-compat/static-1.4754",
  "react-tinymce": "/react-tinymce/static-1.55613",
  "tinymce-config": "/tinymce-config/static-2.54739",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10492",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3559",
  "HeadJS": "/HeadJS/static-2.775",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3272",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "hs-locale-management": "/hs-locale-management/static-1.188",
  "ui-fonts": "/ui-fonts/static-1.873",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4464",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.881",
  "web-vitals": "/web-vitals/static-1.8",
  "batch-promise": "/batch-promise/static-1.1684",
  "external-options-client-types": "/external-options-client-types/static-1.4233",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.891",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8066",
  "graphql": "/graphql/static-1.84",
  "persist-promise": "/persist-promise/static-1.3841",
  "reporting-client-types": "/reporting-client-types/static-1.2586",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "growth-payments-core": "/growth-payments-core/static-1.25786",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5017",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1239",
  "quartz-routing": "/quartz-routing/static-1.646",
  "hs-story-utils": "/hs-story-utils/static-1.9563",
  "react-flip-move": "/react-flip-move/static-1.73",
  "nested-table": "/nested-table/static-1.379",
  "timezone-utils": "/timezone-utils/static-2.5383",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4483",
  "floating-ui": "/floating-ui/static-1.59",
  "react-aria": "/react-aria/static-1.68",
  "tanstack-table": "/tanstack-table/static-1.57",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-test": "/quartz-test/static-1.891",
  "quartz-tracking": "/quartz-tracking/static-1.595",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.206",
  "chirp-fetch": "/chirp-fetch/static-1.2027",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6128",
  "salesImages": "/salesImages/static-1.528",
  "ts-schema": "/ts-schema/static-1.4188",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3057",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1252",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.319",
  "pulse": "/pulse/static-1.746",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3904",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4244",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.152",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3798",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18802",
  "growth-data-modal": "/growth-data-modal/static-1.5663",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3205",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2317",
  "navigation-components": "/navigation-components/static-1.18350",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5088",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.940",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10397",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7778",
  "ui-universal-auth": "/ui-universal-auth/static-1.9146",
  "user-context": "/user-context/static-1.5248",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10308",
  "magpie-lib": "/magpie-lib/static-1.5644",
  "navigation-messaging": "/navigation-messaging/static-1.7677",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21985",
  "copilot-toolkit": "/copilot-toolkit/static-1.11494",
  "cms-field-types": "/cms-field-types/static-1.4954",
  "content-icons-ui": "/content-icons-ui/static-1.2270",
  "integrations-lib": "/integrations-lib/static-1.16594",
  "calling-global-api": "/calling-global-api/static-1.64972",
  "calling-internal-common": "/calling-internal-common/static-1.31452",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66354",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58648",
  "commerce-products-lib": "/commerce-products-lib/static-1.10081",
  "crm-links": "/crm-links/static-1.6448",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9637",
  "file-manager-components": "/file-manager-components/static-1.24039",
  "formula-editor": "/formula-editor/static-1.14514",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4324",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.773",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49230",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4073",
  "property-value-citations": "/property-value-citations/static-1.2648",
  "smart-property-lib": "/smart-property-lib/static-1.7989",
  "tiered-pricing": "/tiered-pricing/static-1.1596",
  "topics-actions-lib": "/topics-actions-lib/static-1.237",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9209",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.72",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20077",
  "tinymce-themes": "/tinymce-themes/static-1.56709",
  "data-token-picker": "/data-token-picker/static-1.16657",
  "hub-http-contrib": "/hub-http-contrib/static-1.3183",
  "interframe": "/interframe/static-3.4898",
  "tinymce-data": "/tinymce-data/static-1.40824",
  "tinymce-plugins": "/tinymce-plugins/static-1.57853",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5350",
  "onboarding-scopes": "/onboarding-scopes/static-1.6600",
  "ui-addon-opt": "/ui-addon-opt/static-4.8501",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4791",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.476",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.313",
  "purchase-motions-api": "/purchase-motions-api/static-1.6131",
  "event-emitter": "/event-emitter/static-1.1089",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.249",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2212",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2345",
  "user-context-client": "/user-context-client/static-1.4718",
  "idb-keyval": "/idb-keyval/static-1.46",
  "magpie-types": "/magpie-types/static-1.5104",
  "nest": "/nest/static-1.373",
  "reactive-lib": "/reactive-lib/static-1.865",
  "simple-logging-lib": "/simple-logging-lib/static-1.3188",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.942",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17920",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1199",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14009",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5747",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7920",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10502",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.660",
  "calling-error-reporting": "/calling-error-reporting/static-1.31459",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11175",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6682",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1508",
  "customer-data-tracking": "/customer-data-tracking/static-1.7026",
  "commerce-permissions": "/commerce-permissions/static-1.914",
  "products-iframe-lib": "/products-iframe-lib/static-1.8315",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10692",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9656",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4290",
  "video-components-external": "/video-components-external/static-1.11747",
  "video-data-lib": "/video-data-lib/static-1.35405",
  "bark-lib": "/bark-lib/static-1.16605",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.97",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6030",
  "react-codemirror": "/react-codemirror/static-1.10767",
  "data-agent-kit": "/data-agent-kit/static-1.430",
  "feedback-loader": "/feedback-loader/static-1.29560",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10393",
  "fsm": "/fsm/static-1.3870",
  "policy-lib": "/policy-lib/static-1.6925",
  "react-colorpicker": "/react-colorpicker/static-2.10347",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10456",
  "FileManagerLib": "/FileManagerLib/static-1.39679",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9160",
  "FileManagerCore": "/FileManagerCore/static-1.39538",
  "content-assistance-lib": "/content-assistance-lib/static-1.7979",
  "layout-dnd-components": "/layout-dnd-components/static-1.12722",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11697",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10024",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15797",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15191",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7745",
  "breeze-engine-core": "/breeze-engine-core/static-1.477",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3151",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.83",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.543",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.645",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.808",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.102",
  "slack-ui-library": "/slack-ui-library/static-1.10538",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36285",
  "sales-views-client-types": "/sales-views-client-types/static-1.4397",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3692",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12752",
  "content-media-compositions": "/content-media-compositions/static-2.16759",
  "media-bridge-lib": "/media-bridge-lib/static-1.19174",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.15978",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4649",
  "storybook-react": "/storybook-react/static-1.35",
  "audio-components": "/audio-components/static-1.6135",
  "FileManagerImages": "/FileManagerImages/static-1.37190",
  "video-components": "/video-components/static-1.13749",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4674",
  "video-embed": "/video-embed/static-1.36239",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8845",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28947",
  "ContentData": "/ContentData/static-1.68847",
  "layout-data-lib": "/layout-data-lib/static-1.10022",
  "social-insights-client-types": "/social-insights-client-types/static-1.22418",
  "outpost": "/outpost/static-1.4309",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6718",
  "advanced-menus-core": "/advanced-menus-core/static-1.15367",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12272",
  "ExportDialog": "/ExportDialog/static-6.10519",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34422",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15366",
  "simple-menus-lib": "/simple-menus-lib/static-1.16883"
}
};
